
import { computed, defineComponent, onMounted, reactive } from 'vue'

// @components
import Loader from '@/common/components/UI/Loader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// @composable
import useNotifications from '@/common/composable/useNotifications'

// @realisations
import { security } from '@/core/realisations/security.realisation'

// @types
import { SecurityHistoryItemT } from '@/core/types/security.types'

export default defineComponent({
    components: { Loader, TheButton },
    props: {
        identifier: {
            type: String,
            default: null,
        },
        type: {
            type: Number,
            default: null,
        },
    },
    setup(props) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            history: [] as SecurityHistoryItemT[],
        })

        const loadHistory = async () => {
            try {
                state.is_loading = true

                const params = {
                    identifier: props.identifier,
                    type: props.type,
                }

                const response = await security.getSbHistory(params)
                state.history = response.data

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении истории проверки СБ произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        onMounted(loadHistory)

        const getTitle = (is_accepted: boolean) => {
            let result = 'Ранее '

            switch (props.type) {
                case 1:
                    result += 'физ. лицу было '
                    break
                case 2:
                    result += 'юр. лицу было '
                    break
                case 3:
                    result += 'авто было '
                    break
            }

            result += is_accepted ? 'разрешено' : 'отказано'

            return result
        }

        return {
            state,
            loadHistory,
            getTitle,
        }
    },
})
